export default __webpack_public_path__ + "static/media/WUPic.c1fae98c.jpg";